module.exports = __webpack_public_path__ + "static/media/A.6c173585.svg";